module.exports = __webpack_public_path__ + "img/13.2fad9270.png";